<template>
  <div class="examination_box">
    <xmlNavBack v-if="!$store.getters.isLayout" />
    <iframe :src="src" frameborder="0" class="iframe" id="iframe"></iframe>
    <integralBox v-show="!$route.query.integral" class="topLeft" ref="integralBox"></integralBox>
    <!-- <robot
      v-if="showRobot"
      ref="robotBox"
      :goodsId="$route.query.goodsId"
      :bookName="$route.query.bookName"
    /> -->
  </div>
</template>
<script>
import integralBox from "@/components/integralBox.vue";
import robot from "@/components/robot.vue";
import xmlNavBack from '../components/xmlNavBack.vue'
import { testURL } from "@/utils/config.js";
export default {
  data() {
    return {
      dictType: "oc_teach_property",
      activeName: "material",
      catalogType: "law_type",
      activeIndex: 0,
      src: "",
      showRobot: false,
    };
  },
  components: { integralBox, robot, xmlNavBack },
  watch: {
    //监听
    $route(to, from) { },
  },
  created() {
    let isAi = ""
    if (this.$route.query.showAi) {
      isAi = "&showAi=true&isAnalysis=true"
    }
    if (this.$store.getters.threePlatform == 'xueKeKnowledgeBaseSys') {
      isAi += "&showAi=true&isAnalysis=true&answer_platform=ouc_knowledge_graph"
    }
    this.src =
      testURL +
      // 'http://192.168.1.196:9000' +
      // 'https://testpaper.airlib.com:10019' +
      "/answer?testPaperId=" +
      this.$route.query.testPaperId +
      "&userId=" +
      this.$route.query.userId +
      "&userName=" +
      this.$route.query.userName +
      "&params1=" +
      this.$route.query.goodsId + "&params2=" + (this.$route.query.params2 || "") + isAi
  },
  mounted() {
    this.$refs.integralBox.isAddIntegral(); //阅读进度
    window.addEventListener("message", this.handleMessage);
    this.$nextTick(() => {
      setTimeout(() => {
        this.sendMessageToIframe()
      }, 3000)
    })
  },
  methods: {
    handleMessage(event) {
      if (event.origin == testURL) {
        let data = event.data.data;

        if (data.type == "showAi" && data.code == "success") {
          this.showRobot = true;
        } else if (data.type == "AiAnalysis" && data.code == "success") {
          this.$refs.robotBox.robotShwo = true;
          this.$refs.robotBox.sending(data.value.replace(/&nbsp;/gi, ""));
        }
      }
    },
    sendMessageToIframe() {
      let iframe = document.getElementById('iframe');
      iframe.contentWindow.postMessage(JSON.parse(localStorage.getItem('xiaoZhi')), '*');
      console.log('发送信息', iframe);

    }
  }
};
</script>
<style scoped lang='scss'>
.examination_box {
  width: 1450px;
  height: 100vh;
  margin: 0 auto;
  background: #f2f2f2;
}

.iframe {
  width: 100%;
  height: 100%;
}
</style>